import styled from "styled-components"
import { Badge } from "~components/portfolio/styled/portfolio"
import { PROOF_OF_OWNERSHIP_STATUS } from "~constants/proofOfOwnership"
import { ButtonPrimarySoftLarge } from "~styled/button"
import { ProofOfOwnership } from "~shapes/proofOfOwnership"
import colors from "~constants/colors"

interface Props {
  item: ProofOfOwnership
  changeStatus: (v) => void
}

const ValidationButton = ({ item, changeStatus }: Props) => {
  const color =
    item.state === PROOF_OF_OWNERSHIP_STATUS.INVALIDATED
      ? colors.black
      : colors.green
  const handleClick = () => {
    changeStatus(PROOF_OF_OWNERSHIP_STATUS.VALIDATING)
  }

  return (
    <div>
      {item.state === PROOF_OF_OWNERSHIP_STATUS.CREATED ? (
        <ButtonPrimarySoftLarge onClick={handleClick}>
          Start validation
          <BtnKbd>⏎</BtnKbd>
        </ButtonPrimarySoftLarge>
      ) : (
        <Badge color={color}>{item.state}</Badge>
      )}
    </div>
  )
}

// Keycap shown inside the action button. Inherits the button's text colour via
// currentColor so it reads correctly on the soft button, matching the keycaps
// used in the validation action bar.
const BtnKbd = styled.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 10px;
  padding: 0 5px;
  font-family: inherit;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  color: currentColor;
  border: 1px solid currentColor;
  border-radius: 4px;
  opacity: 0.65;
`

export default ValidationButton
